// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FrequencyByLiftResponse implements flatbuffers.IUnpackableObject<FrequencyByLiftResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrequencyByLiftResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrequencyByLiftResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FrequencyByLiftResponse,
  ): FrequencyByLiftResponse {
    return (obj || new FrequencyByLiftResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFrequencyByLiftResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: FrequencyByLiftResponse,
  ): FrequencyByLiftResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrequencyByLiftResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  totalCount(): string | null;
  totalCount(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  totalCount(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fault(): string;
  fault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  fault(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  detailedFault(): string;
  detailedFault(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  detailedFault(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  liftType(): string;
  liftType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftType(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  total(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startFrequencyByLiftResponse(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addTotalCount(builder: flatbuffers.Builder, totalCountOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, totalCountOffset, 0);
  }

  static addFault(builder: flatbuffers.Builder, faultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, faultOffset, 0);
  }

  static addDetailedFault(builder: flatbuffers.Builder, detailedFaultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, detailedFaultOffset, 0);
  }

  static addLiftType(builder: flatbuffers.Builder, liftTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, liftTypeOffset, 0);
  }

  static addTotal(builder: flatbuffers.Builder, total: number) {
    builder.addFieldInt32(6, total, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(7, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(8, liftId, 0);
  }

  static endFrequencyByLiftResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 10); // fault
    builder.requiredField(offset, 12); // detailed_fault
    builder.requiredField(offset, 14); // lift_type
    return offset;
  }

  static createFrequencyByLiftResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    totalCountOffset: flatbuffers.Offset,
    faultOffset: flatbuffers.Offset,
    detailedFaultOffset: flatbuffers.Offset,
    liftTypeOffset: flatbuffers.Offset,
    total: number,
    bankId: number,
    liftId: number,
  ): flatbuffers.Offset {
    FrequencyByLiftResponse.startFrequencyByLiftResponse(builder);
    FrequencyByLiftResponse.addBankName(builder, bankNameOffset);
    FrequencyByLiftResponse.addLiftName(builder, liftNameOffset);
    FrequencyByLiftResponse.addTotalCount(builder, totalCountOffset);
    FrequencyByLiftResponse.addFault(builder, faultOffset);
    FrequencyByLiftResponse.addDetailedFault(builder, detailedFaultOffset);
    FrequencyByLiftResponse.addLiftType(builder, liftTypeOffset);
    FrequencyByLiftResponse.addTotal(builder, total);
    FrequencyByLiftResponse.addBankId(builder, bankId);
    FrequencyByLiftResponse.addLiftId(builder, liftId);
    return FrequencyByLiftResponse.endFrequencyByLiftResponse(builder);
  }

  unpack(): FrequencyByLiftResponseT {
    return new FrequencyByLiftResponseT(
      this.bankName(),
      this.liftName(),
      this.totalCount(),
      this.fault(),
      this.detailedFault(),
      this.liftType(),
      this.total(),
      this.bankId(),
      this.liftId(),
    );
  }

  unpackTo(_o: FrequencyByLiftResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.totalCount = this.totalCount();
    _o.fault = this.fault();
    _o.detailedFault = this.detailedFault();
    _o.liftType = this.liftType();
    _o.total = this.total();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): FrequencyByLiftResponseT {
    const t = new FrequencyByLiftResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("total_count")) {
      t.totalCount = this.totalCount();
    }
    if (fieldSet.has("fault")) {
      t.fault = this.fault();
    }
    if (fieldSet.has("detailed_fault")) {
      t.detailedFault = this.detailedFault();
    }
    if (fieldSet.has("lift_type")) {
      t.liftType = this.liftType();
    }
    if (fieldSet.has("total")) {
      t.total = this.total();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class FrequencyByLiftResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public totalCount: string | Uint8Array | null = null,
    public fault: string | Uint8Array | null = null,
    public detailedFault: string | Uint8Array | null = null,
    public liftType: string | Uint8Array | null = null,
    public total: number = 0,
    public bankId: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fault === null || this.fault === undefined) {
      throw new Error('Required field "fault" is not set');
    }
    if (this.detailedFault === null || this.detailedFault === undefined) {
      throw new Error('Required field "detailed_fault" is not set');
    }
    if (this.liftType === null || this.liftType === undefined) {
      throw new Error('Required field "lift_type" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const totalCount = this.totalCount !== null ? builder.createString(this.totalCount!) : 0;
    const fault = this.fault !== null ? builder.createString(this.fault!) : 0;
    const detailedFault =
      this.detailedFault !== null ? builder.createString(this.detailedFault!) : 0;
    const liftType = this.liftType !== null ? builder.createString(this.liftType!) : 0;

    return FrequencyByLiftResponse.createFrequencyByLiftResponse(
      builder,
      bankName,
      liftName,
      totalCount,
      fault,
      detailedFault,
      liftType,
      this.total,
      this.bankId,
      this.liftId,
    );
  }

  clone(): FrequencyByLiftResponseT {
    const obj = new FrequencyByLiftResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.totalCount = this.totalCount;
    obj.fault = this.fault;
    obj.detailedFault = this.detailedFault;
    obj.liftType = this.liftType;
    obj.total = this.total;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: FrequencyByLiftResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.totalCount !== other.totalCount) return false;
    if (this.fault !== other.fault) return false;
    if (this.detailedFault !== other.detailedFault) return false;
    if (this.liftType !== other.liftType) return false;
    if (this.total !== other.total) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyFrequencyByLiftResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "fault");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "detailed_fault");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "lift_type");
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
  } finally {
    verifier.popDepth();
  }
}
